import { ArrowRight, Headphones, ListPlus, Mic2, Play, QrCode, Sparkles } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import { ProviderBadge } from '../components/provider-badge';
import { SongRail } from '../components/song-rail';
import { TvButton } from '../components/tv-button';
import { useAppState } from '../state/app-state';

export function HomePage() {
  const { data, addToQueue } = useAppState();
  const navigate = useNavigate();
  if (!data) return null;
  const heroSong = data.featured.find((song) => song.capabilities.playable) ?? data.featured[0];
  const demos = data.featured.filter((song) => song.providerKind === 'demo');
  const ready = data.providers.filter((provider) => provider.enabled && provider.status === 'ready');

  return (
    <div className="home-page">
      <section className="home-hero">
        <div className="home-hero__copy">
          <span className="hero-kicker"><Sparkles size={18} /> 今晚推荐 · 随时能唱</span>
          <h2>{heroSong?.title || '把客厅变成舞台'}</h2>
          <p>{heroSong ? `${heroSong.artist} · ${heroSong.genre || '家庭 K 歌'}` : '连接你的曲库，和皮皮一起开唱。'}</p>
          {heroSong && (
            <div className="home-hero__meta">
              <ProviderBadge kind={heroSong.providerKind} />
              {heroSong.capabilities.scoring && <span><Mic2 size={17} />实时评分</span>}
              {heroSong.capabilities.offline && <span><Headphones size={17} />离线可唱</span>}
            </div>
          )}
          <div className="hero-actions">
            <TvButton tone="primary" onClick={() => heroSong && navigate(`/play/${encodeURIComponent(heroSong.id)}`)} disabled={!heroSong}>
              <Play size={22} fill="currentColor" /> 立即开唱
            </TvButton>
            <TvButton onClick={() => heroSong && void addToQueue(heroSong)} disabled={!heroSong}>
              <ListPlus size={22} /> 加入点歌台
            </TvButton>
          </div>
        </div>
        <div className="home-hero__visual" aria-hidden>
          <div className="stage-ring stage-ring--one" />
          <div className="stage-ring stage-ring--two" />
          <img src="/brand/pipi-karaoke-mascot.png" alt="" />
          <span className="floating-note floating-note--one">♪</span>
          <span className="floating-note floating-note--two">♫</span>
        </div>
        <div className="home-hero__providers">
          <span>已就绪曲库</span>
          <div>{ready.slice(0, 5).map((provider) => <ProviderBadge key={provider.id} kind={provider.kind} />)}</div>
        </div>
      </section>

      <section className="quick-strip">
        <button type="button" data-tv-focusable onClick={() => navigate('/search')}>
          <span className="quick-strip__icon"><Mic2 /></span><span><small>想唱什么</small><strong>搜索歌曲</strong></span><ArrowRight />
        </button>
        <button type="button" data-tv-focusable onClick={() => navigate('/queue')}>
          <span className="quick-strip__icon"><ListPlus /></span><span><small>{data.queue.length} 首等待中</small><strong>查看点歌台</strong></span><ArrowRight />
        </button>
        <button type="button" data-tv-focusable className="remote-card" onClick={() => window.open(data.remote.remoteUrl, '_blank')}>
          <span className="quick-strip__icon"><QrCode /></span><span><small>手机扫码点歌</small><strong>PIN {data.remote.pin}</strong></span>
          <QRCodeSVG value={data.remote.remoteUrl} size={52} bgColor="transparent" fgColor="#fff9e9" />
        </button>
      </section>

      <SongRail title="先和皮皮热个身" eyebrow="开箱即唱" songs={demos} moreTo="/library?provider=demo" />
      <SongRail title="最近加入" eyebrow="你的统一曲库" songs={data.recentlyAdded} moreTo="/library" />
      <SongRail title="收藏的歌" eyebrow="一按就能找到" songs={data.favorites} moreTo="/favorites" />
    </div>
  );
}
